import axios from "axios";
import BASE_URL from "../assets/global/url";
export const checkDrNumber = async (drNumber, invoice_id) => {
  try {
    // const response = await api.get(`/dr/check/${drNumber}`);
    const response = axios.post(`${BASE_URL}/invoice/isDrExist`, null, {
      params: {
        drNumber: drNumber,
        invoice_id: invoice_id,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
